import React, { useMemo } from 'react';

import {
  Grid2 as Grid,
  grid2Classes as gridClasses,
  Skeleton,
  styled,
  useTheme,
} from '@mui/material';

import { ResponsiveGrid } from '@mewa/ui';

import Img from '../../../components/image';
import { mobileImageHeight, mobileImageWidth } from '../helper';

export const LoadingFormExperiment = ({
  imageSrc,
  mobileImageSrc,
}: {
  imageSrc: string;
  mobileImageSrc: string;
}) => {
  const theme = useTheme();

  // Memoize image to prevent flickering image on re-render.
  const stickyImage = useMemo(() => {
    return (
      <ImageWrapper>
        <Img
          alt=""
          images={[
            {
              src: `${mobileImageSrc}`,
              media: `(max-width: ${theme.breakpoints.values.mdSm - 1}px)`,
              width: mobileImageWidth,
              height: mobileImageHeight,
            },
            {
              src: `${imageSrc}`,
              media: `(min-width: ${theme.breakpoints.values.mdSm}px)`,
              width: 960,
              height: 1181,
            },
          ]}
          style={{
            minHeight: '100%',
            objectFit: 'cover',
          }}
        />
      </ImageWrapper>
    );
  }, [imageSrc, mobileImageSrc, theme]);

  return (
    <Grid
      container
      columns={{ xs: 1, mdSm: 2 }}
      direction={{ mdSm: 'row-reverse' }}
    >
      <Grid
        size={1}
        sx={{
          display: 'block',
          [`&.${gridClasses.root}`]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
        }}
      >
        {stickyImage}
      </Grid>
      <Grid size={1}>
        <ResponsiveGrid>
          <Grid
            size={12}
            sx={{
              marginTop: ['60px', '80px', null, '176px'],
            }}
          >
            <StyledSkeleton variant="rectangular" height={'50px'} />
            <StyledSkeleton
              variant="text"
              height={'50px'}
              sx={{ marginTop: '20px' }}
            />
            <Skeleton
              variant="rectangular"
              sx={{ width: ['100%', '80%'], marginTop: '40px' }}
              height={'350px'}
            />
            <Skeleton
              variant="rectangular"
              sx={{ width: ['100%', '80%'], marginTop: '40px' }}
              height={'350px'}
            />
          </Grid>
        </ResponsiveGrid>
      </Grid>
    </Grid>
  );
};

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  height: '118px',
  width: '100%',
  [theme.breakpoints.up('mdSm')]: {
    width: '50%',
  },
}));

const ImageWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('mdSm')]: {
    position: 'sticky',
    height: '100vh',
    top: 0,
    marginTop: 'calc(-1 * var(--header-height))',

    '.gatsby-image-wrapper': {
      height: '100vh',
    },
  },
}));
